import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import infoIcon from "../../../assets/icons/infoIcon.svg"

import { convertToLocalCurrency } from "../../../utils/currency";
import checkIcon from "../../../assets/icons/check.svg"
//import verifiedIcon from "../../../assets/icons/verified.svg"
import emailVerifiedIcon from "../../../assets/icons/emailVerified.svg"
import emailNotVerifiedIcon from "../../../assets/icons/emailNotVerified.svg"

import { getAdvertiserById, statusAdvertiser } from "../../../redux/slices/advertiserSlice";

import BackButton from "../../../components/common/BackButton";
import { Container, Details } from "./ViewAdvertisersStyles";

const ViewAdvertisers = () => {
  const dispatch = useDispatch();
  const { advertiserId } = useParams();
  const userRole = localStorage.getItem('userRole');
  //console.log(advertiserId)

  const { advertiser, loading } = useSelector((state) => state.advertiser);

  useEffect(() => {
    dispatch(getAdvertiserById(advertiserId));
  }, [dispatch, advertiserId]);
  if (!advertiser) {
    return <div> </div>;
  }

  const handleApproveClick = () => {
    dispatch(statusAdvertiser({id: advertiser?.id, state: "APPROVED"}))
    .unwrap()
    .then(() => {
      dispatch(getAdvertiserById(advertiserId));
    })
    .catch((error) => {
      console.error("Failed to update advertiser status:", error);
    });
  }

const handleRejectClick = () => {
  Swal.fire({
    title: "Are you sure?",
    text: "You are about to reject this advertiser. This action cannot be undone.",
    icon: null, 
      iconHtml:
          `<img src=${infoIcon} alt="error" style="width:50px;">`,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, Reject",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      dispatch(statusAdvertiser({ id: advertiser?.id, state: "REJECTED" }))
        .unwrap()
        .then(() => {
          dispatch(getAdvertiserById(advertiserId));
          //Swal.fire("Rejected!", "The advertiser has been rejected.", "success");
        })
        .catch((error) => {
          console.error("Failed to update advertiser status:", error);
          //Swal.fire("Error!", "There was an error rejecting the advertiser.", "error");
        });
    }
  });
};

  return (
    <Container>
      {loading ? <div></div>
      :
      <>
      <div className="heading">
        <div className="texts">
          <h1>{advertiser.firstName || "N/A"} {advertiser.lastName || "N/A"}</h1>
          <p>Access all essential information and metrics for this advertiser.</p>
        </div>

        <div className="link-buttons">
        <BackButton></BackButton>
          <Link className="add-campaign" to="/create-advertiser">
            + Add advertiser
          </Link>
        </div>
      </div>
    
      <h4>Basic details</h4>
      <Details>
        <div className="wrapper">
            <label>Advertiser's name</label>
            <p>{advertiser.firstName || "N/A"} {advertiser.lastName || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
            <label>Email</label>
            <p>
              {advertiser.email || "N/A"} 
              <span>
                <img className="email-icon"
                  src={advertiser.emailVerified ? emailVerifiedIcon : emailNotVerifiedIcon} 
                  alt={advertiser.emailVerified ? "verified" : "not verified"} 
                />
              </span>
            </p>
        </div>
        <hr />

        {/* <div className="wrapper">
            <label>Email Verified</label>
            <p>{advertiser.emailVerified ? 'Yes' : 'No' || "N/A"}</p>
        </div>
        <hr /> */}

        <div className="wrapper">
            <label>Phone number</label>
            <p>{advertiser.phoneNumber || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
            <label>Skype ID</label>
            <p>{advertiser.skype || "N/A"}</p>
        </div>
      </Details>
      <hr className="outside"/>

      <h4>Campaign Figures</h4>
      <Details>
        <div className="wrapper">
            <label>Amount spent</label>
            <p>{convertToLocalCurrency(advertiser.amountSpent) || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
            <label>No. of campaigns</label>
            <p>{advertiser.campaignCount || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
            <label>Campaign clicks</label>
            <p>{advertiser.clicks || "0"}</p>
        </div>

        <hr />
        <div className="wrapper">
            <label>Conversions</label>
            <p>{advertiser.conversions || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
            <label>Conversion rate</label>
            <p>{`${advertiser.conversionRate}%` || "0"}</p>
        </div>
      </Details>
      <hr className="outside"/>

      <h4>Status</h4>
      <Details>
      <div className="wrapper">
            <label>Pending</label>
            {advertiser?.isApproved === "PENDING" ? <img src={checkIcon} alt="check" /> : null}
        </div>
        <hr />
        <div className="wrapper">
            <label>Approved</label>
            {advertiser?.isApproved === "APPROVED" ? <img src={checkIcon} alt="check" /> : null}
        </div>
        <hr />
        <div className="wrapper">
            <label>Rejected</label>
            {advertiser?.isApproved === "REJECTED" ? <img src={checkIcon} alt="check" /> : null}
        </div>
      </Details>
      <hr className="outside"/>
      
      {userRole === 'SUPPORT' ? '' : (
      <div className="approval">
            <div></div>
            <div className="link-buttons">
              <button
                className="see-more"
                onClick={handleRejectClick}
                disabled={advertiser?.isApproved === "REJECTED"}
              >
                Reject
              </button>
              <button
                className="add-campaign"
                onClick={handleApproveClick}
                disabled={advertiser?.isApproved === "APPROVED"}
              >
                Approve
              </button>
            </div>
          </div>
      )}
      </>
      }
    </Container>
  );
};

export default ViewAdvertisers;
